// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4692":"d5e79295","7240":"0832f934","8042":"1332cbcf","9802":"d361687a"}[chunkId] + ".chunk.css";
};